<template>
  <p v-if="isPrint" class="print-textarea">{{ inputValue }}</p>
  <vs-textarea v-else ref="mlTextarea" :rows="rows" :counter="isInputSelected && !readonly ? max : 0" v-model="inputValue" :readonly="readonly" :placeholder="placeholder" class="vsTextArea" @focus="handleFocus" @blur="handleBlur" />
</template>

<script>
export default {
  name: "MaxLengthTextarea",
  props: {
    isPrint: { type: Boolean, default: false },
    value: { type: String | Number, default: "" },
    placeholder: String,
    readonly: Boolean,
    rows: { type: Number | String, default: 5 },
    max: { type: Number, default: 2000 },
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
    inputValue: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length > this.max) {
          this.inputValue = this.value;
          alert(`${this.max}자까지 작성할 수 있습니다.`);
          // this.$refs.mlTextarea.focus();
        } else {
          this.$emit("input", value);
        }
      },
    },
  },
  data() {
    return {
      inputValue: this.value,
      isInputSelected: false,
    };
  },
  methods: {
    handleFocus() {
      this.isInputSelected = true;
    },
    handleBlur() {
      if (!this.isInputSelected) return;
      this.isInputSelected = false;
      this.$emit("blur", this.inputValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.vsTextArea::v-deep {
}
</style>
